import React from 'react';

import classNames from 'classnames';

export interface ICountProps {
    number: number;
    className?: string;
    color: 'grey' | 'green' | 'red' | 'red-medium';
    size: 'sm'| 'm' | 'lg' ;
}

const Count = ({
    color = 'grey',
    size = 'sm',
    className,
    number,
}: ICountProps): JSX.Element => {
    const computedClassName: string = classNames(
        'count',
        {
            [`count--color-${color}`]: !!color,
            [`count--size-${size}`]: !!size,
        },
        className,
    );

    return (
        <div className={computedClassName}>
            {number}
        </div>
    );
};

export default Count;
